import { JSONSchema7 } from 'json-schema';
import { createAnswerSchema } from '../answerSchemaFields';
import { createQuestionSchemaWithMixins, questionImage } from '../questionSchemaFields';
import { config } from './PrototypeScreen.config';

const areaAnswerSchema = createAnswerSchema({
  properties: {
    area: {
      type: 'object',
      properties: {
        type: { const: 'box' },
        x: { type: 'number' },
        y: { type: 'number' },
        w: { type: 'number' },
        h: { type: 'number' },
      },
      required: ['type', 'x', 'y', 'w', 'h'],
    },
    targetId: { type: 'string' },
  },
  required: ['area'],
});

export const exclusivePrototypeAnswerSchema = createAnswerSchema({
  type: 'object',
  properties: {
    exclusiveAnswer: { const: true },
  },
  required: ['exclusiveAnswer'],
} as const);

export const schema = createQuestionSchemaWithMixins({
  mixins: { questionImage },
  base: {
    properties: {
      isFinal: { type: 'boolean' },
    },
  },
  type: config.name,
  answer: { oneOf: [areaAnswerSchema, exclusivePrototypeAnswerSchema] as JSONSchema7[] },
});
